module.exports = __webpack_public_path__ + "media/images/icon-81278b4492473479992ac2d81b27c733.jpg";